import { DatePipe } from '@angular/common'
import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

import { VistaUpload } from '../../shared'

@Component({
    templateUrl: './vista-upload-details.component.html',
    standalone: true,
    imports: [DatePipe],
})
export class VistaUploadDetailsComponent {
    upload!: VistaUpload

    constructor(private activeModal: NgbActiveModal) {}

    close(): void {
        this.activeModal.dismiss()
    }
}
